/**
 * Removes a specified suffix from the end of a string, if it exists.
 *
 * @param str The input string.
 * @param suffix The suffix to remove.
 * @returns The string with the suffix removed, or the original string if the suffix was not found.
 */
export const removeSuffix = (
  str: string | null | undefined,
  suffix: string
): string => {
  if (!str) {
    return "";
  }
  if (str.endsWith(suffix)) {
    return str.slice(0, -suffix.length);
  }
  return str;
};
